import { Button } from "../../../components/ui/button.jsx";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../../../components/ui/dialog.jsx";

import UserForm from "./UserForm";

const UserCreateDialog = ({ open, onOpenChange, newUser, setNewUser, onSubmit, isEdit = false }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{isEdit ? "Edit User" : "Create New User"}</DialogTitle>
          <DialogDescription>
            {isEdit
              ? "Update user information and project access."
              : "Add a new user to the system. They will be able to log in with the email and password provided."}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-6 pt-4">
          <UserForm formData={newUser} setFormData={setNewUser} isEdit={isEdit} />
          <Button type="submit" variant="primary" className="w-full py-6 rounded-lg">
            {isEdit ? "Update User" : "Create User"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default UserCreateDialog;
